import { useMemo } from "react";
import { useSeguroFicha } from "./SeguroFicha";
import ProcedimientoPrecio from "../../Components/Configuracion/ProcedimientoPrecio/ProcedimientoPrecio";

/* ============================================================================
   SEGUROS-PLANES FASE 2 · pestaña Tarifario.

   Es la pantalla de Tarifarios YA REDISEÑADA, sin una copia ni una variante:
   el mismo componente, con la aseguradora fijada por la ruta en vez de elegida
   en un selector. Buscar, filtrar por categoría, paginar, crear, editar,
   importar y exportar siguen siendo exactamente los mismos flujos contra los
   mismos endpoints.

   `seguroFijo` va memoizado A PROPÓSITO: es un objeto, y sin `useMemo` cambia
   de identidad en cada render. Como `ProcedimientoPrecio` lo tiene entre las
   dependencias de su carga inicial, un objeto nuevo cada vez significaría una
   petición del tarifario por render.
   ========================================================================== */

export default function SeguroTarifario() {
    const { seguro, idseguro } = useSeguroFicha();

    const seguroFijo = useMemo(
        () => ({ value: idseguro, label: seguro.nombre }),
        [idseguro, seguro.nombre]
    );

    return <ProcedimientoPrecio seguroFijo={seguroFijo} />;
}
